__turbopack_context__.v({
  "Footer": "Footer-module-scss-module__dU5k9q__Footer",
  "Icon": "Footer-module-scss-module__dU5k9q__Icon",
  "Info": "Footer-module-scss-module__dU5k9q__Info",
  "InfoText": "Footer-module-scss-module__dU5k9q__InfoText",
  "Inner": "Footer-module-scss-module__dU5k9q__Inner",
  "KmoSection": "Footer-module-scss-module__dU5k9q__KmoSection",
  "LinkItem": "Footer-module-scss-module__dU5k9q__LinkItem",
  "Logo": "Footer-module-scss-module__dU5k9q__Logo",
  "Menu": "Footer-module-scss-module__dU5k9q__Menu",
  "OfficeLogo": "Footer-module-scss-module__dU5k9q__OfficeLogo",
  "OfficeLogoImage": "Footer-module-scss-module__dU5k9q__OfficeLogoImage",
  "SecondaryLogoImage": "Footer-module-scss-module__dU5k9q__SecondaryLogoImage",
  "SocialLinks": "Footer-module-scss-module__dU5k9q__SocialLinks",
  "SubFooter": "Footer-module-scss-module__dU5k9q__SubFooter",
});
